import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { preloadPage } from './routing/lazyPage';
import './index.css';

// Ensure that the DOM is loaded before rendering
const render = () => {
  const root = document.getElementById('root');
  if (root) {
    ReactDOM.createRoot(root).render(
      <React.StrictMode>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </React.StrictMode>
    );
  }
};

// Load the current page's code before the first render, so the prerendered HTML is
// replaced by the page itself rather than by a loading spinner (see routing/lazyPage).
// The static HTML stays on screen meanwhile; never wait more than a few seconds.
const start = () => {
  const timeout = new Promise((resolve) => setTimeout(resolve, 4000));
  Promise.race([preloadPage(window.location.pathname).catch(() => undefined), timeout]).then(render);
};

// Handle the case where the DOM is not yet ready
if (document.readyState === 'loading') {
  window.addEventListener('DOMContentLoaded', start);
} else {
  start();
}
